import GenericError from '../GenericError'
import { DatabaseInfo, Table, Columns } from './../Database/DatabaseInterface';
import { StationAdapter } from '../Adapters/StationAdapter';

class IndexedDB extends StationAdapter {
	constructor() {
		super();

		if (!window.indexedDB && !window.mozIndexedDB && !window.webkitIndexedDB && !window.msIndexedDB) {
			console.log('Browser does not support indexedDB');
			return;
		}

		this.createIndexedDB(Table.stationsTable, Columns.stationsColumns);
	}

	createIndexedDB(table, columns) {
		const openDbRequest = window.indexedDB.open(DatabaseInfo.dbName, parseInt(DatabaseInfo.version, 10) || 1);

		openDbRequest.onupgradeneeded = function (event) {
			const db = event.target.result;

			if (db.objectStoreNames.contains(table)) { // Clear table if exists
				db.deleteObjectStore(table);
			}

			const tableStore = db.createObjectStore(table, {
				keyPath: 'id',
				autoIncrement: true
			});

			columns.forEach(column => {
				if (column === 'id') return;
				tableStore.createIndex(column, column, {
					unique: false
				});
			});
		}

		openDbRequest.onerror = function () {
			console.log("IndexedDB hasn't been created!");
		}
	};

	fetchSpecificData = async (table, column, values) => {
		const transaction = await this.getDBTransaction(table);
		const objectStore = transaction.objectStore(table);

		if (!objectStore) return;

		let list = [];
		const index = objectStore.index(column[0]);
		const lValue = typeof values[0] === 'boolean' ? values[0].toString() : values[0];

		return new Promise((resolve, reject) => {
			const updateRequest = index.openCursor(IDBKeyRange.only(lValue));

			updateRequest.onsuccess = (e) => {
				const cursor = e.target.result;

				if (!cursor) return;

				list.push(this.fromApi(cursor.value));

				cursor.continue();
			}

			updateRequest.onerror = (error) => {
				var e = new GenericError();
				e.setAndLogMessage("Error: " + error);
				reject(e);
			}

			transaction.oncomplete = () => {
				resolve(list);
			}
		})
	}

	// fetch(table, columns, values, operators) {
	// 	return new Promise((resolve) => {
	// 		const list = [];
	// 		let conditionStatement = "";

	// 		if (columns != null && columns.length > 0) {
	// 			conditionStatement += " WHERE ";
	// 			conditionStatement += this._createConditionStatement(columns, operators);
	// 		} else {
	// 			conditionStatement += ";";
	// 		}

	// 		if (values == null) {
	// 			values = [];
	// 		}

	// 		let sqlStatement = 'SELECT * FROM ' + table + conditionStatement;

	// 		this.db.each(sqlStatement, values, (result) => { // TODO: route animation bug
	// 			list.push(this.fromApi(result));
	// 		})

	// 		resolve(list);
	// 	})
	// }

	_createConditionStatement(columns, operators) {
		let columnStatement = "";

		for (let i = 0; i < columns.length; i++) {
			let operator = "=";

			if (operators != null && operators[i] != null) {
				operator = operators[i];
			}

			columnStatement += columns[i] + operator + "? ";

			if (i !== columns.length - 1) {
				columnStatement += "AND ";
			}
		}

		return columnStatement;
	}

	// search = (table, column, values) => {
	// 	return new Promise((resolve, reject) => {
	// 		const searchedList = [];

	// 		if (!this.db) {
	// 			var e = new GenericError();
	// 			e.setAndLogMessage("Database hasn't been created!");
	// 			reject(e);
	// 		} else {
	// 			var statement = "SELECT * FROM stations WHERE sound LIKE '" + values[0] + "%' UNION ALL SELECT * FROM " + table + " WHERE " + column + " LIKE '% %" + values[0] + "%' LIMIT 20";

	// 			this.db.each(statement, [], (result) => {
	// 				searchedList.push(this.fromApi(result));
	// 			})

	// 			resolve(searchedList);
	// 		}
	// 	})
	// }

	update = async (table, cond, update, station) => {
		var objectStore = (await this.getDBTransaction(table)).objectStore(table);

		if (!objectStore) return;

		const storeIndex = objectStore.index(cond.column);
		const updateRequest = storeIndex.openCursor(IDBKeyRange.only(cond.value && +cond.value))

		updateRequest.onsuccess = async (event) => {
			const cursor = event.target.result;

			if (!cursor) {
				await this.addToIndexedDB(objectStore, station, update);

				return;
			};

			const currentValue = cursor.value;
			currentValue[update.column] = (typeof update.value === 'boolean' && update.value.toString()) || update.value;

			const updateRequest = cursor.update(currentValue);

			updateRequest.onerror = function (error) {
				var e = new GenericError();
				e.setAndLogMessage("Update table Error: " + error);
			}
		}

		updateRequest.onerror = (error) => {
			var e = new GenericError();
			e.setAndLogMessage("Open Cursor Error: " + error);
		}
	};

	async checkTableRowsCount(table) {
		const objectStore = (await this.getDBTransaction(table)).objectStore(table);

		if (!objectStore) return;

		return new Promise((resolve) => {
			const countRequest = objectStore.count();

			countRequest.onsuccess = function () {
				resolve(countRequest.result || null);
			}

			countRequest.onerror = function () {
				resolve(null);
			}
		})
	}

	addToIndexedDB(aObjectStore, aStation, aUpdate) {
		return new Promise((resolve, reject) => {
			aStation[aUpdate.column] = (typeof aUpdate.value === 'boolean' && aUpdate.value.toString()) || aUpdate.value;
			delete aStation.id;

			const dataInsert = aObjectStore.add(aStation);

			dataInsert.onsuccess = function () {
				resolve();
			}

			dataInsert.onerror = function (error) {
				var e = new GenericError();
				e.setAndLogMessage("Update table Error: " + error);
				reject()
			}
		})
	}

	getDBTransaction(table) {
		return new Promise((resolve, reject) => {
			const openDbRequest = window.indexedDB.open(DatabaseInfo.dbName, parseInt(DatabaseInfo.version, 10) || 1);

			openDbRequest.onsuccess = function (event) {
				let db = event.target.result;
				let transaction = db.transaction(table, DatabaseInfo.access);
				resolve(transaction);
			}

			openDbRequest.onerror = function () {
				console.log("Database hasn't been created!");
				reject();
			}
		})
	}

	// dropTable(table) {
	// 	return new Promise((resolve, reject) => {
	// 		var openDbRequest = window.indexedDB.open(DatabaseInfo.dbName, parseInt(DatabaseInfo.version, 10) || 1);

	// 		openDbRequest.onupgradeneeded = (event) => {
	// 			let db = event.target.result;
	// 			let dropedObj = db.deleteObjectStore(table);

	// 			dropedObj.onsuccess = function () {
	// 				resolve();
	// 			}

	// 			dropedObj.onerror = function () {
	// 				var e = new GenericError();
	// 				e.setAndLogMessage("Drop table Error: " + dropedObj.error);
	// 				reject(e);
	// 			}
	// 		}

	// 		openDbRequest.onerror = function () {
	// 			console.log("Database hasn't been created!");
	// 		}
	// 	})
	// }

	// query(statement, callback) {
	// 	var rows = [];
	// 	var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
	// 	db.transaction(function (transaction) {
	// 		transaction.executeSql(statement, [], function (transaction, result) {
	// 			if (result != null && result.rows != null) {
	// 				for (var i = 0; i < result.rows.length; i++) {
	// 					var row = result.rows.item(i);
	// 					rows.push(row);
	// 				}
	// 				callback(rows);
	// 			}
	// 		}, (transaction, error) => {
	// 			var e = new GenericError();
	// 			e.setAndLogMessage("SQL query Error: " + error.message);
	// 			callback(null, e);
	// 		});
	// 	}, (transaction, error) => {
	// 		var e = new GenericError();
	// 		e.setAndLogMessage("Error: " + transaction.message);
	// 		callback(null, e);
	// 	});
	// };
}

export default IndexedDB;